import Control from 'ol/control/Control'

import { getLayerFromMapById, mapsToBeSteered, setMapsToBeSteered } from '../map/tools'
import { getMapsToBeSteered } from '../qualityCheck/getset'

export let blurredButton;
export const setBlurredButton = (b) => blurredButton = b;

// Suitable icons:
// <i class="material-icons">satellite</i>\
// <i class="material-icons">queue</i>\
// <i class="material-icons">playlist_add</i>\
// <i class="material-icons">photo_library</i>\
// <i class="material-icons">wallpaper</i>\
// <i class="material-icons">tune</i>\
// <i class="material-icons">compare</i>\
// <i class="material-icons">terrain</i>\
// <i class="material-icons">panorama</i>\
// <i class="material-icons">map</i>\
// <i class="material-icons">layers</i>\
// <i class="material-icons">crop_original</i>\

function updateChoicesAccordingToMap(m) {
  // un/check basemap layer (when it was together with other layers):
  const bmIndex = m.get('groupPosition') - 1; // before WMSes
  const currentBasemap = m.getLayers().getArray()[bmIndex].get('type');
  const toBeChecked = document.getElementById(currentBasemap);
  if (toBeChecked) toBeChecked.checked = true;
  // un/check wms layers:
  const wmsLayers = document.getElementsByClassName('wms');
  for (let i = 0; i < wmsLayers.length; i++) {
    const cb = wmsLayers[i];
    cb.checked = false;
  }
  getLayerFromMapById(m, 'wmsGroup').getLayers().forEach(wms => {
    if (!wms.getVisible()) return;
    for (let i = 0; i < wmsLayers.length; i++) {
      const cb = wmsLayers[i];
      if (cb.id === wms.get('id')) {
        // console.log(cb.id, '--> same, check it');
        cb.checked = true;
        break;
      }
    }
  });
  const l1 = m.getLayers().item(0);
  if (l1.get('id') === 'OSM' && l1.getVisible()) OSM.checked = true;
}

// Layer choice button.
export class LayerButtonControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) { button.id = options.id; }
    button.innerHTML = '<i class="material-icons">layers</i>';
    button.title = 'Andre kartlag';

    const element = document.createElement('div');
    element.className = 'layers-button ol-unselectable ol-control';
    if (options.id) {
      element.id = 'div-' + options.id;
      element.classList.add('mini-layers-button');
    }
    element.appendChild(button);
    if (options.position) {
      const p = options.position;
      element.style.bottom = p + 'px';
      document.getElementById('mapLayerSelector').classList.add('t' + p);
    }

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggleChoices.bind(this));
    button.addEventListener('blur', this.hideChoices.bind(this));
  }
  toggleChoices = (e) => {
    setMapsToBeSteered(getMapsToBeSteered(e.currentTarget.id));
    updateChoicesAccordingToMap(mapsToBeSteered[0]);
    mapLayerSelector.classList.toggle('closed');
  };
  hideChoices = (e) => {
    // console.log('save blurring to be able to focus again');
    blurredButton = e.target;
    if (document.getElementById('mapLayerSelector').matches(':hover')) return;
    document.getElementById('mapLayerSelector').classList.add('closed');
  };
}

